import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const unPromoteAdminGroupAction = createAsyncAction(
  '@chat/UN_PROMOTE_ADMIN_GROUP_REQUEST',
  '@chat/UN_PROMOTE_ADMIN_GROUP_SUCCESS',
  '@chat/UN_PROMOTE_ADMIN_GROUP_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingUnPromoteAdminGroup: true
})

const success = (state: ChatState, action: ActionType<typeof unPromoteAdminGroupAction.success>): ChatState => {
  const { updatedChatData } = action.payload
  return {
    ...state,
    activeChat: { ...state.activeChat, ...updatedChatData },
    isSuccessOnUnPromoteAdminGroup: true,
    isLoadingUnPromoteAdminGroup: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingUnPromoteAdminGroup: false,
  isErrorOnUnPromoteAdminGroup: true
})

export const unPromoteAdminGroupHandle = { asyncAction: unPromoteAdminGroupAction, request, success, failure }
